const ARAM_MAP_ID = 'aram_proving_grounds';

/**
 * mapAllowsTrainingExtras — Sandbox Garen/dummy/jungle props (not ARAM).
 */
export function mapAllowsTrainingExtras(mapId) {
  return mapId !== ARAM_MAP_ID;
}

export function filterTrainingSecondaries(mapId, secondaries) {
  if (!mapAllowsTrainingExtras(mapId)) return [];
  return (secondaries || []).filter(Boolean);
}

/**
 * Hide/show training meshes + plates for the active map.
 */
export function applyTrainingExtraVisibility({
  mapId,
  garenGroup,
  garenPlate,
  dummyGroup,
  dummyPlateDiv,
  sandboxPropGroups = []
} = {}) {
  const show = mapAllowsTrainingExtras(mapId);
  if (garenGroup) garenGroup.visible = show;
  if (garenPlate) garenPlate.style.display = show ? 'flex' : 'none';
  if (dummyGroup) dummyGroup.visible = show;
  if (dummyPlateDiv) dummyPlateDiv.style.display = show ? 'flex' : 'none';
  for (const group of sandboxPropGroups) {
    if (group) group.visible = show;
  }
  return show;
}
